import Alpine from 'alpinejs';
window.Alpine = Alpine;

//Modules list

import cart from "./cart";
Alpine.store('cart', cart);

import modalStore from "./modalStore";
Alpine.store('modalStore', modalStore);

import modal from "./modal";
Alpine.data('modal', modal);

import form from "./form";
Alpine.data('form', form);

import alert from "./alert";
Alpine.data('alert', alert);

import callback from "./callback";
Alpine.data('callback', callback);

import category from "./category";
Alpine.data('category', category);

import addCart from "./addCart";
Alpine.data('addCart', addCart);

import smallCart from "./smallCart";
Alpine.data('smallCart', smallCart);

import fullCart from "./fullCart";
Alpine.data('fullCart', fullCart);

import cartItem from "./cartItem";
Alpine.data('cartItem', cartItem);

import order from "./order";
Alpine.data('order', order);

import pagination from "./pagination";
Alpine.data('pagination', pagination);

//--End Modules list

//Alpine start
Alpine.start();
